<template>
  <div class="pageBox">
    <div class="content">
      <div class="applicationBox">
        <el-form
            ref="form"
            class="formBox"
            :model="form"
            :rules="rules"
            :validate-on-rule-change="false"
            label-width="auto">
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="应用名称" prop="appName">
                <el-input
                    aria-label="应用名称"
                    aria-autocomplete="none"
                    clearable
                    placeholder="请输入应用名称"
                    type="text"
                    v-model.trim="form.appName"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="应用包名" prop="appPackage">
                <el-input
                    aria-label="应用包名"
                    aria-autocomplete="none"
                    clearable
                    placeholder="请填写应用的包名，提交后不可修改"
                    type="text"
                    v-model.trim="form.appPackage"
                    :disabled="$route.query.appPackage && $route.query.appPackage!==''"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="ICON" prop="appIcon" class="apkIconBox">
                <el-upload
                    class="uploader"
                    multiple
                    accept=".png, .jpg"
                    :action="configBaseURL+'/api/uploadFile'"
                    :data="{type:'appIcon'}"
                    :show-file-list="false"
                    :on-success="res=>{return handleUpload(res,'appIcon',1)}"
                    :before-upload="beforeUpload"
                >
                  <div class="img-box" v-for="item in form.appIcon" :key="item">
                    <img :src="item"/>
                    <i class="el-icon-delete" @click="handleRemove($event,item,'appIcon')"></i>
                  </div>
                  <div slot="trigger" v-if="form.appIcon.length < 1" class="add-box">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-upload>
                <div class="msg">
                  请上传应用ICON，图片格式jpg、png，像素140*140。
                  <br>
                  文件大小不能超过512Kb。
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="应用截图" prop="screenshot" class="apkIconBox">
                <el-upload
                    class="uploader"
                    :disabled="form.screenshot && form.screenshot.length >= 5"
                    multiple
                    accept=".png, .jpg"
                    :action="configBaseURL+'/api/uploadFile'"
                    :data="{type:'screenshot'}"
                    :show-file-list="false"
                    :on-success="res=>{return handleUpload(res,'screenshot',5)}"
                    :before-upload="beforeUpload"
                >
                  <div class="img-box" v-for="item in form.screenshot" :key="item">
                    <img :src="item"/>
                    <i class="el-icon-delete" @click="handleRemove($event,item,'screenshot')"></i>
                  </div>
                  <div slot="trigger" v-if="form.screenshot.length < 5" class="add-box">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-upload>
                <div class="msg">
                  请上传应用在OPPO、vivo、小米、华为等任意开发者平台的截图证明（如企业名称、营业执照、应用的上架截图等），
                  图片格式jpg、png，文件大小不能超过512Kb，最多5张图片。
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item>
                <div class="text-center">
                  <el-button
                      class="w200"
                      @click="$router.back(-1)">
                    取消
                  </el-button>
                  <el-button
                      type="primary"
                      class="w200 "
                      @click="submitForm('form')">
                    提交
                  </el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <members-dialog v-if="error" ref="membersDialog" :error="error"></members-dialog>
    <success-dialog ref="successDialog"></success-dialog>
  </div>
</template>
<script>
import membersDialog from "./dialog/membersDialog";//各家开放平台弹框
import successDialog from "./dialog/successDialog";//各家成功弹窗
export default {
  components: {
    membersDialog, successDialog
  },
  data() {
    var checkAppPackage = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请填写应用包名"));
      } else {
        let reg = /[\u4E00-\u9FA5]/g;
        if (reg.test(value)) {
          callback(new Error("应用包名不可输入中文"));
        } else {
          callback();
        }
      }
    };
    return {
      error: "", //提交认证错误信息
      form: {
        appName: "", //应用名称
        appPackage: "", //应用包名
        appIcon: [], //图标
        screenshot: [], //截图
      },
      detail: '', //  详情数据JSON，用于对比新旧表单是否发生更改
      rules: {
        appName: [
          {required: true, message: "请输入应用名称", trigger: "change"},
          {max: 15, message: '最大限制15个字', trigger: 'change'}
        ],
        appPackage: [
          {required: true, message: "请填写应用包名", trigger: "change"},
          {max: 320, message: '最大限制320个字', trigger: 'change'},
          {validator: checkAppPackage, trigger: "change"},
        ],
        appIcon: [
          {required: true, message: "请上传Icon", trigger: "change"}
        ],
        screenshot: [
          {required: true, message: "请上传应用截图", trigger: "submit"}
        ],
      },
    };
  },
  created() {
    if (this.$route.query.appId) {
      this.handleDetail()
    }
  },
  methods: {
    // 获取详情
    handleDetail() {
      this.$apis.consoleSever.queryDetail({
        id: this.$route.query.appId,
      }).then(res => {
        if (res.code === 0) {
          this.form = {
            ...this.form,
            ...res.data,
            appIcon: [res.data.appIcon || ''],
          }
          this.detail = JSON.stringify(this.form)
        }
      })
    },
    //上传前校验
    beforeUpload({size,name}) {
      const fileType = name.substring(name.lastIndexOf('.'));
      if(['.jpg','.png'].indexOf(fileType) === -1){
        this.$message.error(`只支持jpg、png格式图片`);
        return false
      }
      const isSize = size / 1024 <= 512;
      if (!isSize) {
        this.$message.error(`上传文件大小不能超过 512kb`);
        return false
      }
      return true;
    },
    //上传成功
    handleUpload(res, key, limit) {
      if (res.code === 0) {
        // 数量限制
        if (this.form[key].length >= limit) {
          this.$message.error(`最多上传数量为${limit}`);
          return false;
        }
        this.form[key].push(res.data.link)
        this.$refs.form.validateField(key);
      } else {
        this.$message.error(res.message);
      }
    },
    // 删除文件
    handleRemove(e, link, list) {
      e.stopPropagation();
      this.form[list] = this.form[list].filter(item => item !== link)
    },
    //提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 判断表单内容是否未发生更改
          if (this.detail === JSON.stringify(this.form)) {
            this.$msgBox.alertMessageBox({
              title: "创建失败",
              content: '信息没有改变',
              btnText: '好的',
            })
            return;
          }
          const formData = {
            ...this.form,
            appIcon: this.form.appIcon[0],
            screenshot: this.form['screenshot'].join(','),
          }
          const api = this.form.id ? 'edit' : 'add'
          this.$apis.consoleSever[api](formData).then((res) => {
            if (res.code === 0) {
              this.$msgBox.alertMessageBox({
                title: "创建成功",
                content: `${formData.appName}创建申请已提交，请耐心等待运营审核。`,
              }).then(() => {
                this.$router.push({
                  path: "/console/appLink/app/list",
                });
              })
            } else {
              this.$msgBox.alertMessageBox({
                title: "创建失败",
                content: res.message,
                btnText: '好的',
              })
            }
          })
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.pageBox {
  padding: 20px;
  border-radius: 5px;
  min-height: calc(100% - 94px); //减底部(20px+ICP高度+20px)
  .content {
    background: #fff;
    box-shadow: $--background-shadow-base;

    .applicationBox {
      padding: 70px 50px;

      .formBox {
        width: 1000px;

        /deep/ .el-form-item__label {
          color: #999 !important;
        }

        .msg {
          color: #999;
          line-height: 26px;
        }

        .padding-t7 {
          padding-top: 7px;
        }

        .specialApkPackageList {
          margin-bottom: 22px;

          .label {
            width: 80px;
          }
        }
      }
    }

    .msgBox {
      margin: 10px auto;

      .msg {
        position: relative;
        height: 30px;
        font-size: 14px;
        color: rgba(153, 153, 153, 1);
        line-height: 30px;

        &:after {
          content: "";
          position: absolute;
          top: 50%;
          left: -10px;
          width: 5px;
          height: 5px;
          transform: translateY(-50%);
          border-radius: 50%;
          background: #999;
        }
      }
    }

    .uploader {
      display: flex;
      flex-wrap: wrap;

      /deep/ .el-upload {
        display: flex;
        flex-wrap: wrap;
        order: 100;
      }

      .img-box, .add-box {
        width: 148px;
        height: 148px;
        border-radius: 6px;
        margin: 0 8px 8px 0;
      }

      .img-box {
        border: 1px solid #c0ccda;
        overflow: hidden;
        position: relative;

        img {
          width: 100%;
          height: 100%;
        }

        .el-icon-delete {
          position: absolute;
          top: 0;
          left: 0;
          display: none;
          cursor: pointer;

          &:before {
            position: absolute;
            font-size: 22px;
            color: #fff;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }

        &:hover .el-icon-delete {
          display: inline;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          -webkit-transition: opacity .3s;
          transition: opacity .3s;
        }
      }

      .add-box {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        box-sizing: border-box;
        cursor: pointer;
        line-height: 146px;

        .el-icon-plus {
          font-size: 28px;
          color: #8c939d;
        }

        &:hover {
          border-color: #2E84FC;
          color: #2E84FC;
        }
      }
    }
  }
}
</style>

